import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import JoinForm from '../components/JoinForm';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  paddingTop: '2rem',
  paddingBottom: '4rem',
  backgroundColor: '#F8FAFC'
}));

const HeroSection = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: '4rem'
}));

const BenefitsSection = styled(Box)(({ theme }) => ({
  marginBottom: '4rem'
}));

const BenefitCard = styled(Box)(({ theme }) => ({
  padding: '2rem',
  height: '100%',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #E2E8F0',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    borderColor: '#2563EB',
    '& .benefitIcon': {
      backgroundColor: '#2563EB',
      color: '#FFFFFF'
    }
  }
}));

const BenefitIcon = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '16px',
  backgroundColor: '#EFF6FF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.5rem',
  transition: 'all 0.3s ease',
  '& svg': {
    fontSize: '32px',
    color: '#2563EB'
  }
}));

const benefits = [
  {
    icon: <WorkIcon />,
    title: 'Projets Innovants',
    description: 'Participez à des projets stimulants dans le domaine de la métrologie de pointe.'
  },
  {
    icon: <GroupsIcon />,
    title: 'Équipe Dynamique',
    description: 'Rejoignez une équipe passionnée et bénéficiez d\'un environnement de travail collaboratif.'
  },
  {
    icon: <TrendingUpIcon />,
    title: 'Évolution de Carrière',
    description: 'Développez vos compétences et évoluez dans une entreprise en pleine croissance.'
  },
  {
    icon: <EmojiObjectsIcon />,
    title: 'Innovation Continue',
    description: 'Contribuez à l\'innovation dans le domaine de la métrologie et de la qualité de l\'air.'
  }
];

const Carrieres = () => {
  return (
    <PageContainer>
      <Container maxWidth="lg">
        <HeroSection>
          <Typography
            variant="h1"
            sx={{
              fontSize: '3rem',
              fontWeight: '700',
              color: '#1E293B',
              marginBottom: '1rem'
            }}
          >
            Rejoignez le Groupe airmetrologie et L2MI
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: '1.25rem',
              color: '#64748B',
              maxWidth: '800px',
              margin: '0 auto'
            }}
          >
            Nous recherchons des talents passionnés pour contribuer à l'innovation
            dans le domaine de la métrologie .
          </Typography>
        </HeroSection>

        <BenefitsSection>
          <Grid container spacing={4}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <BenefitCard>
                  <BenefitIcon className="benefitIcon">
                    {benefit.icon}
                  </BenefitIcon>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: '1.25rem',
                      fontWeight: '600',
                      color: '#1E293B',
                      marginBottom: '1rem'
                    }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6
                    }}
                  >
                    {benefit.description}
                  </Typography>
                </BenefitCard>
              </Grid>
            ))}
          </Grid>
        </BenefitsSection>

        <JoinForm />
      </Container>
    </PageContainer>
  );
};

export default Carrieres;
